import React, { useRef, useEffect } from 'react';
import VanillaTilt from 'vanilla-tilt';
import styles from './Stat.module.scss';
import CountUp from '../UI/CountUp';

const TotalTransactions = ({ title, value, icon, bgColor }) => {
  const cardRef = useRef(null);

  useEffect(() => {
    const isDesktop = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    if (cardRef.current && isDesktop) {
      VanillaTilt.init(cardRef.current, {
        max: 10,
        speed: 1000,
        perspective: 1000,
        glare: true,
        'max-glare': 0.1,
        scale: 1,
        reset: true,
      });
    }

    return () => {
      if (cardRef.current && cardRef.current.vanillaTilt) {
        cardRef.current.vanillaTilt.destroy();
      }
    };
  }, []);

  return (
    <div className={styles.stats__block} ref={cardRef}>
      <h4 className={styles.stats__subtitle}>{title}</h4>

      <h2 className={styles.stats__value}>
        <CountUp from={0} to={value} separator=' ' duration={0.5} />
      </h2>

      <div className={styles.stats__icon} style={{ backgroundColor: bgColor }}>
        <img src={icon} alt={title} className={styles.stats__iconImg} />
      </div>
    </div>
  );
};

export default TotalTransactions;